import { store } from '@webplatform/frontkit';

export default () =>
  store({
    enableConfig: true,
    enableDevice: true,
    enableMenus: true,
  });
